// import cookie from '../../lib/cookie.js'
import '../assets/scss/hosting.scss'
import Vue from "vue"; //eslint-disable-line no-unused-vars
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import { mapState } from 'vuex'
import FileUpload from "@/components/FileUpload";
import { BFormGroup, BFormCheckbox } from "bootstrap-vue";
Vue.component("b-form-group", BFormGroup);
Vue.component("b-form-checkbox", BFormCheckbox);

extend("required", {
	...required,
	message: "This field is required"
});
extend("email", {
	...email,
	message: "Please enter a valid email address"
});
extend('url', {
  validate(value) {
    if (value) {
      return /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(value);
    }

    return false;
  },
  message: 'This value must be a valid URL',
});

export default {
	components: {
		ValidationProvider,
		ValidationObserver,
		FileUpload
	},
	computed: mapState({
		// arrow functions can make the code very succinct!
		userdata: state => state.auth.userdata
	}),
	data() {
		return {
			ticket: {
			},
			attachments: [],
			siteTypeOptions: ['301','Keywordsite','Moneysite']
		};
	},

	mounted: function() {
		console.log(this.userdata)
		this.ticket.TI_FROMMAIL = this.userdata.user_email
		this.ticket.TI_USERID = this.userdata.user_id
		
	},
	methods: {
		transmitForm() {
			this.addTicket();
		},

		addTicket() {
			let that = this;
			this.senddata = {
				TI_DEPT: 'domains',
				TI_USERID: this.userdata.user_id,
				TI_FROMMAIL: this.ticket.TI_FROMMAIL,
				TI_SUBJECT: this.ticket.TI_SUBJECT,
				TI_SITETYPE: this.ticket.TI_SITETYPE,
				TI_STATUS: this.ticket.TI_STATUS,
				
				MSG_USERID:	this.userdata.user_id,
				MSG_SUBJECT: this.ticket.MSG_SUBJECT,
				MSG_URL: this.ticket.MSG_URL,
				MSG_ERRORMESSAGE: this.ticket.MSG_ERRORMESSAGE,
				MSG_ATTACHMENTS: this.attachments.join(","),
				MSG_TEXT: this.ticket.MSG_TEXT
			};
			var headers = {
				headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken') }
			}
			this.$http.post('/tickets/add',this.senddata,headers)
			.then(function (response) {
				that.$toastr.Add({
					title: "Ticket created", // Toast Title
					msg: "",
					position: "toast-top-center",
					type: "success"
				});
				that.$router.push("/tickets/list");
			})
		},
		addImagedata(img) {
			console.log("got " + img.Image + " and " + img.ImageID)
			this.attachments.push(img.ImageID)
		}
	}
};
